<template>
  <modal v-bind="{ title, introClass }">
    <template #intro v-if="intro">
      <p>{{ intro }}</p>
    </template>
    <article class="content" :class="contentClass" v-html="message"/>
    <template #footer>
      <div class="buttons" :class="footerClass">
        <slot v-if="extraButtonsPosition === 'before'" name="buttons"/>
        <action-button :class="buttonClass" @click="$close(true)">{{ buttonText }}</action-button>
        <slot v-if="extraButtonsPosition === 'after'" name="buttons"/>
      </div>
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    title: String,
    message: String,
    intro: String,

    buttonText: {
      type: String,
      default: 'Okay'
    },

    introClass: Array | Object | String,
    contentClass: Array | Object | String,
    footerClass: Array | Object | String,

    buttonClass: {
      type: Array | Object | String,
      default: 'is-primary'
    },

    extraButtonsPosition: {
      type: String,
      default: 'before',
      validator: value => ['before', 'after'].includes(value)
    }
  }
}
</script>
